import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';

import type { DispatchRequestStatus } from './types';

const NS = 'operations';

const VARIANTS: Record<DispatchRequestStatus, 'default' | 'secondary' | 'outline' | 'destructive'> =
  {
    draft: 'secondary',
    submitted: 'outline',
    routed: 'default',
    accepted: 'default',
    fulfilled: 'default',
    rejected: 'destructive',
    cancelled: 'destructive',
  };

/**
 * Status chip shared by all three dispatch surfaces. `fulfilled` renders with
 * a green tint to read as a success terminal state without diverging from the
 * shadcn badge variants list.
 */
export const DispatchStatusBadge = ({ status }: { status: DispatchRequestStatus }) => {
  const { t } = useTranslation(NS);
  const variant = VARIANTS[status] ?? 'secondary';
  const greenClass =
    status === 'fulfilled'
      ? 'bg-green-100 text-green-900 dark:bg-green-900/40 dark:text-green-100 border-transparent'
      : '';
  return (
    <Badge variant={variant} className={greenClass}>
      {t(`efs.operations.dispatch.statuses.${status}`, { defaultValue: status })}
    </Badge>
  );
};

export default DispatchStatusBadge;
